export function RadioGroupIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
      <path d="M3.496 9.997a6.5 6.5 0 0 0 5.866 6.469c.213.558.515 1.072.889 1.526a7.999 7.999 0 1 1 7.74-7.743a5.5 5.5 0 0 0-1.528-.888a6.5 6.5 0 0 0-12.967.636m5.617 3.39a3.501 3.501 0 1 1 4.272-4.274a5.5 5.5 0 0 1 1.516-.099A5.002 5.002 0 0 0 4.998 10a5 5 0 0 0 4.017 4.903a5.6 5.6 0 0 1 .098-1.516m.779-1.89a5.5 5.5 0 0 1 1.602-1.604a1.5 1.5 0 1 0-1.602 1.603M14.5 19a4.5 4.5 0 1 0 0-9a4.5 4.5 0 0 0 0 9m0-7a.5.5 0 0 1 .5.5V14h1.5a.5.5 0 0 1 0 1H15v1.5a.5.5 0 0 1-1 0V15h-1.5a.5.5 0 0 1 0-1H14v-1.5a.5.5 0 0 1 .5-.5" />
    </svg>
  );
}
